import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Congratulations!",
description: "You’ve completed the Freon tutorial! Review what you’ve built, explore further documentation, and discover ideas to extend your Computer Aided Learning DSL or contribute to the Freon project.",
tags: [ "Freon", "tutorial", "completion", "DSL", "Computer Aided Learning", "examples", "interpreter", "LionWeb", "styling", "contributors", "next steps"] ,
modifiedTime: "2025-11-07T19:14:57.506Z",
publishedTime: "2025-11-07T17:20:18.626Z"
    }
  };
};